const projects = [
  {
    number: "01",
    type: "Artist platform",
    title: "Atelier for Artists",
    description:
      "A platform for artists to present customizable portfolios and manage commission requests, client messages, pricing, and contracts.",
    tech: ["React", "Node.js / Express", "PostgreSQL", "Railway"],
    image: "/atelier-preview.png",
    imageAlt: "Atelier for Artists website preview",
    link: "https://www.atelierforartists.com/",
    linkLabel: "Visit Atelier",
  },
  {
    number: "02",
    type: "Workflow application",
    title: "Jetski Maintenance Tracker",
    description:
      "A full-stack application for organizing personal watercraft maintenance schedules, built around a practical ownership workflow.",
    tech: ["React", "C#", "PostgreSQL", "Railway"],
    image: "/jetski-preview.png",
    imageAlt: "Jetski Maintenance Tracker preview",
    link: "https://frontend-production-9c1d.up.railway.app",
    linkLabel: "Open the app",
  },
  {
    number: "03",
    type: "Time and reporting",
    title: "DayBook",
    description:
      "A time tracking application that helps users record work and generate reports.",
    tech: ["Next.js", "React", "PostgreSQL", "Railway"],
    image: "/daybook-preview.png",
    imageAlt: "DayBook time tracking app preview",
    link: "https://daybook-production-f10a.up.railway.app/",
    linkLabel: "Open the app",
  },
  {
    number: "04",
    type: "AI assistant",
    title: "Jarvis Personal Assistant",
    description:
      "A personal assistant app that lets users choose between language models through the OpenRouter API.",
    tech: ["Next.js", "React", "PostgreSQL", "OpenRouter"],
    image: "/jarvis-preview.png",
    imageAlt: "Jarvis Personal Assistant preview",
    link: "https://jarvis-production-83c4.up.railway.app/",
    linkLabel: "Open the app",
  },
];

function ProjectCard({ project, featured }) {
  return (
    <article className={featured ? "project-card project-card--featured" : "project-card"}>
      <a
        className="project-card__image"
        href={project.link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={project.linkLabel + ": " + project.title}
      >
        <img src={project.image} alt={project.imageAlt} loading="lazy" />
        <span className="project-card__number">{project.number}</span>
      </a>
      <div className="project-card__body">
        <p className="eyebrow">{project.type}</p>
        <h3>{project.title}</h3>
        <p className="project-card__description">{project.description}</p>
        <div className="tag-list">
          {project.tech.map((technology) => <span key={technology}>{technology}</span>)}
        </div>
        <a className="text-link" href={project.link} target="_blank" rel="noopener noreferrer">
          {project.linkLabel} <span aria-hidden="true">↗</span>
        </a>
      </div>
    </article>
  );
}

export default function Projects() {
  return (
    <section className="section" id="work">
      <div className="section-wrap">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Selected work</p>
            <h2>Software built around real tasks.</h2>
          </div>
          <p className="section-heading__aside">
            A selection of web products and workflow-focused applications.
          </p>
        </div>
        <div className="project-grid">
          {projects.map((project, index) => (
            <ProjectCard key={project.number} project={project} featured={index === 0} />
          ))}
        </div>
      </div>
    </section>
  );
}
